export default "__VITE_ASSET__CLaYBe3Z__"